import VueFormGenerator from "vue-form-generator";

export const GenericFields = {
	checkbox(field, disabled = true) {
		let customCheckboxValidator = (value) => {
			if (!value) {
				return ["Zaznaczenie jest wymagane!"];
			}
			return null;
		};
		return {
			type: "checkbox",
			name: field.label,
			hint: field.hint,
			label: field.label,
			default: true,
			model: field.id,
			validator: field.required ? customCheckboxValidator : null,
			required: field.required,
			disabled: disabled,
			view: field.view,
		};
	},

	numberField(field, disabled = true) {
		let groupField = {
			type: "input",
			inputType: "number",
			hint: field.hint,
			name: field.label,
			label: field.label,
			featured: true,
			required: field.required,
			model: field.id,
			disabled: disabled,
			view: field.view,
		};

		groupField.validator = [];

		if (field.min !== null && field.min !== undefined && field.min !== "") {
			groupField.min = field.min;
		}

		if (field.max !== null && field.max !== undefined && field.max !== "") {
			groupField.max = field.max;
		}

		let requireValueValidator = (value) => {
			if (field.required && (value === "" || value === null || value === undefined || isNaN(value))) {
				return "Pole jest wymagane!";
			}
			return null;
		};
		groupField.validator.push(requireValueValidator);

		let rangeValidator = (value) => {
			if (field.max !== null && field.max !== undefined && value > field.max) {
				return "Liczba jest za duża! Maksymalnie: " + field.max;
			}
			if (field.min !== null && field.min !== undefined && value < field.min) {
				return "Liczba jest za mała! Minimalnie: " + field.min;
			}
			return null;
		};
		groupField.validator.push(rangeValidator);

		let decimalValidator = (value) => {
			if (value === null || value === undefined || Math.floor(value) === value) {
				return null;
			}
			if (value.toString().split(".")[1] && value.toString().split(".")[1].length > 2) {
				return "Należy podać wartość z maksymalnie dwoma miejscami po przecinku.";
			}
			return null;
		};
		groupField.validator.push(decimalValidator);

		return groupField;
	},

	textField(field, disabled = true) {
		let groupField = {
			type: "input",
			inputType: "text",
			hint: field.hint,
			name: field.label,
			label: field.label,
			featured: true,
			required: field.required,
			model: field.id,
			disabled: disabled,
			view: field.view,
			maxlength: 32767
		};

		let validationRules = {};

		if (field.required) {
			validationRules["fieldIsRequired"] = "Pole jest wymagane!";
		}

		if (field.min) {
			validationRules["textTooSmall"] = "Pole musi zawierać co najmniej {1} znaków";
			groupField.min = field.min;
		}
		if (field.max) {
			validationRules["textTooBig"] = "Pole musi zawierać co najwyżej {1} znaków";
			groupField.max = field.max;
		}

		groupField.validator = VueFormGenerator.validators.string.locale(validationRules);

		return groupField;

	},

	permanentField(field, disabled = true) {
		return {
			type: "customTextArea",
			name: field.label,
			label: field.label,
			disabled: true,
			model: field.id,
			view: field.view,
		};
	},

	textAreaField(field, disabled = true) {
		let groupField = {
			type: "customTextArea",
			hint: field.hint,
			name: field.label,
			styleClasses: "facebook",
			label: field.label,
			featured: true,
			required: field.required,
			model: field.id,
			disabled: disabled,
			view: field.view,
		};

		let validationRules = {};

		if (field.required) {
			validationRules["fieldIsRequired"] = "Pole jest wymagane!";
		}

		if (field.min) {
			validationRules["textTooSmall"] = "Pole musi zawierać co najmniej {1} znaków";
			groupField.min = field.min;
		}
		if (field.max) {
			validationRules["textTooBig"] = "Pole musi zawierać co najwyżej {1} znaków";
			groupField.max = field.max;
		}
		groupField.validator = VueFormGenerator.validators.string.locale(validationRules);
		return groupField;
	},

	calendarField(field, disabled = true) {
		let groupField = {
			type: "customCalendar",
			hint: field.hint,
			name: field.label,
			label: field.label,
			featured: true,
			required: field.required,
			model: field.id,
			disabled: disabled,
			view: field.view,
		};

		let validator = (value) => {
			if (field.min && value && (value < field.min)) {
				return "Data musi być późniejsza lub równa " + field.min;
			}
			if (field.max && value && (value > field.max)) {
				return "Data musi być wcześniejsza lub równa " + field.max;
			}
			if (field.required && !value) {
				return "Pole jest wymagane!";
			}
			return null;
		};

		groupField.validator = [validator];

		return groupField;
	},

	listOneChoiceField(field, disabled = true) {
		let groupField = {
			type: "select",
			hint: field.hint,
			name: field.label,
			placeholder: "wybierz",
			label: field.label,
			values: field.options,
			featured: true,
			required: field.required,
			model: field.id,
			selectOptions: {
				noneSelectedText: "Wybierz",
			},
			disabled: disabled,
			view: field.view,
		};

		if (field.required) {
			groupField.validator = VueFormGenerator.validators.required.locale(
				{
					fieldIsRequired: "Pole jest wymagane!",
				},
			);
		}

		return groupField;
	},

	radioListOneChoice(field, disabled = true) {
		let groupField = {
			type: "radios",
			hint: field.hint,
			name: field.label,
			label: field.label,
			values: field.options,
			featured: true,
			required: field.required,
			model: field.id,
			disabled: disabled,
			view: field.view,
		};

		if (field.required) {
			groupField.validator = VueFormGenerator.validators.required.locale(
				{
					fieldIsRequired: "Pole jest wymagane!",
				},
			);
		}
		return groupField;
	},

	checkListField(field, disabled = true) {
		let groupField = {
			type: "checklist",
			listBox: true,
			hint: field.hint,
			name: field.label,
			label: field.label,
			values: field.options,
			featured: true,
			required: field.required,
			multi: true,
			model: field.id,
			disabled: disabled,
			view: field.view,
		};
		if (field.required) {
			groupField.validator = VueFormGenerator.validators.array.locale(
				{
					thisNotArray: "Nic nie zaznaczono",
					fieldIsRequired: "Pole jest wymagane!",
					selectMinItems: "Wymagane jest zaznaczenie minimum {0} możliwości!",
					selectMaxItems: "Wymagane jest zaznaczenie maksimum {0} możliwości!",
				},
			);

			if (field.min) {
				groupField.min = field.min;
			}

			if (field.max) {
				groupField.max = field.max;
			}
		}

		return groupField;
	},

	multiChoiceField(field, disabled = true) {
		let groupField = {
			type: "checklist",
			listBox: disabled,
			hint: field.hint,
			name: field.label,
			label: field.label,
			values: field.options,
			featured: true,
			required: field.required,
			multi: true,
			model: field.id,
			disabled: disabled,
			view: field.view,
		};
		if (field.required) {
			groupField.validator = VueFormGenerator.validators.array.locale(
				{
					thisNotArray: "Nic nie zaznaczono",
					fieldIsRequired: "Pole jest wymagane!",
					selectMinItems: "Wymagane jest zaznaczenie minimum {0} możliwości!",
					selectMaxItems: "Wymagane jest zaznaczenie maksimum {0} możliwości!",
				},
			);

			if (field.min) {
				groupField.min = field.min;
			}

			if (field.max) {
				groupField.max = field.max;
			}
		}
		return groupField;
	},

	attachmentField(field, disabled = true) {
		let customAttachmentValidator = (value) => {
			if (!value) {
				return ["Pole jest wymagane"];
			}
			return null;
		};
		return {
			type: "customAttachment",
			hint: field.hint,
			name: field.label,
			label: field.label,
			featured: true,
			required: field.required,
			link: field.link,
			model: field.id,
			disabled: disabled,
			validator: field.required ? customAttachmentValidator : null,
			view: field.view,
		};
	},

	conditionalField(field, disabled = true) {
		return {
			type: "switch",
			hint: field.hint,
			name: field.label,
			label: field.label,
			textOn: field.textOn,
			textOff: field.textOff,
			featured: false,
			model: field.id,
			value: false,
			disabled: disabled,
			view: field.view,
		};
	},

	tableField(field, disabled = true) {
		let customTableValidator = (value) => {
			if (field.required) {
				if (!value || !Array.isArray(value) || value.length === 0) {
					return ["Tabela jest wymagana!"];
				}
				
				// Sprawdź czy wszystkie wiersze są wypełnione
				for (let i = 0; i < value.length; i++) {
					const row = value[i];
					if (!row || row.some(cell => cell === null || cell === undefined || cell === '')) {
						return ["Wszystkie komórki w tabeli muszą być wypełnione!"];
					}
				}
			}
			return [];
		};
		
		return {
			type: "customTable",
			name: field.label,
			hint: field.hint,
			label: field.label,
			model: field.id,
			required: field.required,
			disabled: disabled,
			view: field.view,
			validator: field.required ? customTableValidator : null,
			columns: field.columns || [],
			maxRows: field.maxRows != null ? field.maxRows : 10,
			minRows: field.minRows || 1,
		};
	},
};